import { render, staticRenderFns } from "./DragAndDropFileInput.vue?vue&type=template&id=c0ba427a&scoped=true"
import script from "./DragAndDropFileInput.vue?vue&type=script&lang=js"
export * from "./DragAndDropFileInput.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropFileInput.vue?vue&type=style&index=0&id=c0ba427a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ba427a",
  null
  
)

export default component.exports